import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_mt-1 _flex _ai-c _gap-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_circle_icon = _resolveComponent("circle-icon")
  const _component_floating_message = _resolveComponent("floating-message")

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock(_component_floating_message, _mergeProps({ key: 0 }, $options.floatingMessageConfig, { "data-qa": "reverse-language-notification" }), {
        icon: _withCtx(() => [
          _createVNode(_component_circle_icon, {
            class: "_shrink-0",
            theme: "circle-info",
            icon: "language"
          })
        ]),
        actions: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "gfu-link gfu-link--accent _fw-b _ttl",
              onClick: _cache[0] || (_cache[0] = (...args) => ($options.toastClose && $options.toastClose(...args))),
              "data-qa": "reverse-language-notification-link:Ok"
            }, "ok, keep this setting"),
            _createElementVNode("button", {
              class: "gfu-link gfu-link--accent _fw-b _ttl",
              onClick: _cache[1] || (_cache[1] = (...args) => ($options.onRevert && $options.onRevert(...args))),
              "data-qa": "reverse-language-notification-link:Revert"
            }, "revert to English")
          ])
        ]),
        _: 1 /* STABLE */
      }, 16 /* FULL_PROPS */))
    : _createCommentVNode("v-if", true)
}